import { cn } from '@/utils'

export interface GroupOption<Key extends string> {
  key: Key
  label: string
  count: number
}

interface TypeGroupsProps<Key extends string> {
  options: GroupOption<Key>[]
  active: Key
  onChange: (key: Key) => void
}

// One-click groups above a list, each with its count. A group with no rows stays visible, greyed.
export const TypeGroups = <Key extends string>({
  options,
  active,
  onChange,
}: TypeGroupsProps<Key>) => (
  <fieldset className="inline-flex flex-wrap gap-0.5 rounded-lg border bg-slate-100 p-[3px]">
    {options.map((option) => (
      <button
        key={option.key}
        type="button"
        aria-pressed={option.key === active}
        disabled={option.count === 0 && option.key !== active}
        onClick={() => onChange(option.key)}
        className={cn(
          'flex h-[26px] cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md px-2.5 text-[13px] font-medium disabled:cursor-not-allowed',
          option.key === active
            ? 'bg-white text-blue-7 shadow-[inset_0_0_0_1px_var(--color-border)]'
            : option.count === 0
              ? 'text-blue-4'
              : 'text-blue-6 hover:text-blue-7',
        )}
      >
        {option.label}
        <span
          className={cn(
            'rounded-full px-1.5 text-xs tabular-nums',
            option.count === 0 ? 'text-blue-4' : 'bg-blue-2 text-blue-7',
          )}
        >
          {option.count.toLocaleString('en-US')}
        </span>
      </button>
    ))}
  </fieldset>
)
